const SnpShape = ({ id, x, y, symbol, fill }) => (
  <g id={id}>
    {symbol === "up-triangle" ? (
      <polygon points={`${x + 4},${y} ${x + 8},${y + 8} ${x},${y + 8}`} fill={fill} />
    ) : symbol === "down-triangle" ? (
      <polygon points={`${x + 4},${y + 8} ${x + 8},${y} ${x},${y}`} fill={fill} />
    ) : (
      <rect x={x} y={y} width={8} height={8} rx={4} fill={fill} />
    )}
  </g>
);

export default SnpShape;
